module.exports = __webpack_public_path__ + "static/media/IMG_0454.c9e86192.JPG";